import React from 'react';
import WhatsAppButton from '@/components/ui/WhatsAppButton';

/**
 * Fixed WhatsApp CTA shown on mobile. Always visible at 100% opacity from
 * page load — no scroll gating, no fade-in — to maximize conversion.
 */
const MobileWhatsAppCTA: React.FC = () => {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] bg-gradient-to-t from-background via-background to-transparent flex items-center justify-center">
      <WhatsAppButton
        text="Falar com especialista"
        source="mobile_cta"
        variant="whatsapp"
        size="lg"
        fullWidth={true}
        showIcon={true}
        className="min-h-[56px] text-base font-semibold shadow-lg hover:shadow-xl transition-all"
      />
    </div>
  );
};

export default MobileWhatsAppCTA;
